import { render } from "./shortCodeProviders.vue?vue&type=template&id=0f7f0f01&scoped=true"
import script from "./shortCodeProviders.vue?vue&type=script&lang=js"
export * from "./shortCodeProviders.vue?vue&type=script&lang=js"

import "./shortCodeProviders.vue?vue&type=style&index=0&id=0f7f0f01&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7f0f01"]])

export default __exports__